import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material/styles';
import { brand } from '@/shared/config/brand';

const sizeMap = {
  sm: 28,
  md: 36,
  lg: 44,
  xl: 52,
} as const;

type BrandLogoProps = {
  size?: keyof typeof sizeMap;
  showTagline?: boolean;
  surface?: 'light' | 'dark';
  sx?: SxProps<Theme>;
  /** Override fixed size with responsive heights (e.g. navbar). */
  responsiveHeight?: { xs?: number; sm?: number; md?: number; lg?: number };
};

export function BrandLogo({
  size = 'md',
  showTagline = false,
  surface = 'dark',
  sx,
  responsiveHeight,
}: BrandLogoProps) {
  const height = sizeMap[size];
  const imgHeight = responsiveHeight ?? height;
  const isLight = surface === 'light';

  const logo = (
    <Box
      component="img"
      src={isLight ? brand.logoUrlOnLight : brand.logoUrl}
      alt="trplin"
      sx={{
        height: imgHeight,
        width: 'auto',
        display: 'block',
        objectFit: 'contain',
        ...(!isLight && {
          filter: 'drop-shadow(0 2px 10px rgba(0, 0, 0, 0.45))',
        }),
      }}
    />
  );

  return (
    <Box sx={sx}>
      {logo}
      {showTagline && (
        <Typography
          sx={{
            display: { xs: 'none', lg: 'block' },
            fontSize: '0.6875rem',
            color: isLight ? 'text.secondary' : 'rgba(255, 255, 255, 0.7)',
            mt: 0.25,
          }}
        >
          {brand.tagline}
        </Typography>
      )}
    </Box>
  );
}
